// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
// import { HolidayService } from '../../../../holiday/services/HolidayService';
// Models
import { User } from '../models/User';
// import { Parent } from '../../../../holiday/models/Parent';
import { Credential } from '../models/Credential';

@Component({
    selector: 'add-parent',
    template: require('./AddParentComponent.html'),
    styles: [require('./AddParentComponent.sass')],
})

export class AddParentComponent implements OnInit {
    credential:     Credential;
    message:        string;
    // parent:     Parent;
    messageType:    string;
    redirectUrl:    string;
    formSubmitted: boolean = false;
    
    constructor(
        // private holidayService: HolidayService,
        private sessionService: SessionService,
        private userService: UserService,
        private router: Router
    ) {
        // this.parent = new Parent();
    }

    ngOnInit() {
        this.redirectUrl = '/booking/students';
        this.credential = new Credential('parent', '', '');
         // Use Session Service to get session and check if user had already logged in.
        this.getSession();
        // this.getParent();
    };

    onSubmit() {
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSession(this.credential);
    }

    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.redirect(this.redirectUrl);
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    /**
     * Post Session to API service to create new session.
     * Update User Data on local storage and redirect to desired URL
     * if request responses session data.
     * @param {Credential} - user credential input
     * @return none
     */
    private postSession(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    // Set user session data
                    this.userService.setUserSessionData(user);

                    // Fire user session data changed event
                    this.userService.userDataChanged(user);

                    // Redirect to desired URL
                    this.router.navigate['/add-student']
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }

    // private getParent() {
    //     this.holidayService.getParent()
    //         .subscribe(
    //             parent => {
    //                 this.parent = parent;
    //                 this.router.navigate['/add-student']
    //             },
    //             error => {
    //                 //TO DO: Handle any error if needed in the furture
    //                 this.message     = "";
    //                 this.messageType = "alert";
    //             }
    //         );
    // }
}



// WEBPACK FOOTER //
// ./src/common/modules/user/parent/AddParentComponent.ts